import { render, staticRenderFns } from "./firebase-keys.vue?vue&type=template&id=0cb1af2a&scoped=true&"
import script from "./firebase-keys.vue?vue&type=script&lang=js&"
export * from "./firebase-keys.vue?vue&type=script&lang=js&"
import style0 from "./firebase-keys.vue?vue&type=style&index=0&id=0cb1af2a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb1af2a",
  null
  
)

export default component.exports